/**
 * T096: useDeleteCategory Hook
 * Mutation hook for deleting categories with warning for assigned prompts
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteCategory } from '@/services/categories'
import { queryKeys } from '@/lib/query-keys'

export function useDeleteCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteCategory(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
      // Also invalidate prompts as they may have been affected
      queryClient.invalidateQueries({ queryKey: queryKeys.prompts.lists() })
    },
  })
}
